/* eslint-disable */
import request from '../utils/request'

const URL = 'taxi/report/'

export const getReportInRange = (data) => request({
  method: 'post',
  url: URL,
  data
})
export const getReportConsolidatedInRange = (data) => request({
  method: 'post',
  url: 'report/park_monthly_report/',
  data
})
